import $ from 'jquery'

$(document).ready(function($) {

  if ($('.jumbotron').hasClass('dark')) {
    $('.header').addClass('dark')
  }

  let lastScrollTop = 0;
  $(window).scroll(function() {
    let st = $(this).scrollTop()
    if ( $(window).scrollTop() > 320) {
      $('.header').addClass('scrolled');
    } else {
      $('.go-top').removeClass('show');
    }
    
    if ( $(window).scrollTop() == 0) {
      $('.header').removeClass('scrolled');
    }

    if (st < lastScrollTop && $(window).scrollTop() > 40) {
      $('.header').addClass('show')
    } else {
      $('.header').removeClass('show')
    }
    lastScrollTop = st;
  });

  var $contentDivs = $('.jumbotron, .section, .main');
  $(document).scroll(function() {
    var stickyOffset = $('.header').offset();
    $contentDivs.each(function(k) {
        var thisOffset = $(this).offset();
        var actPosition = thisOffset.top - $(window).scrollTop();
        if (actPosition < stickyOffset.top && actPosition + $(this).height() > 0) {
          $('.header').not('.opened').removeClass('light dark').addClass($(this).hasClass('dark') ? 'dark' : 'light');
          return false;
        }
    });
  });

});


// WEBPACK FOOTER //
// ./resources/assets/js/partial/header.js